import { qs, listen, add, remove, contains } from '@fluorescent/dom';
import { createFocusTrap } from 'focus-trap';
import PredictiveSearch from '@/lib/predictive-search';

const selectors = {
  trigger: '.quick-search__trigger',
  searchOverlay: '.search__overlay',
  searchInput: '.search__input',
  inputClear: '.search__input-clear',
  inputClose: '.search__input-close',
  results: '.search__results',
};

const classNames = {
  active: 'is-active',
  activeQuery: 'has-active-query',
  activeSuggestions: 'has-suggestions',
};

export default function QuickSearch(node) {
  const trigger = qs(selectors.trigger, node);
  const overlay = qs(selectors.searchOverlay, node);
  const searchInput = qs(selectors.searchInput, node);
  const searchInputClear = qs(selectors.inputClear, node);
  const searchInputClose = qs(selectors.inputClose, node);
  const resultsContainer = qs(selectors.results, node);
  const predictiveSearch = PredictiveSearch(resultsContainer);

  const events = [
    listen(trigger, 'click', _showSearchBar),
    listen(overlay, 'click', _hideSearchBar),
    listen(document, 'keydown', _handleEsq),
    listen(searchInput, 'input', _searchInputHandler),
    listen(searchInputClose, 'click', _hideSearchBar),
    listen(searchInputClear, 'click', _clearSearchInput),
  ];

  const trap = createFocusTrap(node, { allowOutsideClick: true });

  function _showSearchBar(e) {
    e.preventDefault();

    add(node, classNames.active);
    trap.activate();
    searchInput.focus();
  }

  function _hideSearchBar(e) {
    e.preventDefault();

    trap.deactivate();
    remove(node, classNames.active);
  }

  function _handleEsq(e) {
    if (contains(node, classNames.active) && e.keyCode === 27) {
      _hideSearchBar(e);
    }
  }

  function _clearSearchInput(e) {
    e.preventDefault();

    searchInput.value = '';
    _searchInputHandler(e);
    searchInput.focus();
  }

  function _searchInputHandler(e) {
    const query = e.target.value;

    if (!query) {
      remove(node, classNames.activeQuery, classNames.activeSuggestions);
      return;
    }

    add(node, classNames.activeQuery, classNames.activeSuggestions);

    predictiveSearch.getSearchResults(e.target.value);
  }

  const unload = () => {
    events.forEach(unsubscribe => unsubscribe());
  };

  return { unload };
}
